export const fallbackOttLogos = {
    netflix:
      "https://upload.wikimedia.org/wikipedia/commons/7/75/Netflix_icon.svg",
  
    "amazon prime video":
      "https://upload.wikimedia.org/wikipedia/commons/f/f1/Prime_Video.png",
  
    "prime video":
      "https://upload.wikimedia.org/wikipedia/commons/f/f1/Prime_Video.png",
  
    "disney plus":
      "https://upload.wikimedia.org/wikipedia/commons/3/3e/Disney%2B_logo.svg",
  
    hotstar:
      "https://upload.wikimedia.org/wikipedia/commons/1/1e/Disney%2B_Hotstar_logo.svg",
  
    zee5:
      "https://upload.wikimedia.org/wikipedia/commons/0/0e/ZEE5_logo.png",
  
    sonyliv:
      "https://upload.wikimedia.org/wikipedia/commons/3/3a/SonyLIV_logo.png",

    "Sun NXT":
       "https://upload.wikimedia.org/wikipedia/commons/7/75/Netflix_icon.svg",
  };


  export const getOttLogoFromProviders = (ottProviders = []) => {
    if (!ottProviders.length) return null;
  
    const providerName = ottProviders[0]?.provider_name;
    if (!providerName) return null;
  
    const key = providerName.toLowerCase().trim();
  
    return fallbackOttLogos[key] || null;
  };
  